module.exports = __webpack_public_path__ + "static/media/no-reports-img.f6a4842b.svg";